import { useQuery } from '@tanstack/react-query';
import useLocaleQueryFilter from '../../utils/useLocaleQueryFilter';
import { ImageType } from './useProducts';

export type AttributeValue = {
  id: number;
  label: string;
  keyLabel: string;
  identifier: string;
  keySorting: number;
  valueSorting: number;
  keyId: number;
  code: string;
  image: ImageType;
};

export type AttributeKey = {
  id: number;
  keyLabel: string;
  sorting: number;
  values: AttributeValue[];
  hideFilter: number;
};

type CategoryIdFilter = {
  categoryId: number;
  subCatList: number[];
};

export default function useAttributes(filter: CategoryIdFilter) {
  const localizedFilter = useLocaleQueryFilter(filter);
  return useQuery<AttributeKey[], Error>(['attributes', localizedFilter]);
}
